import { render, staticRenderFns } from "./WorkTools.vue?vue&type=template&id=dcff45f0&scoped=true&"
import script from "./WorkTools.vue?vue&type=script&lang=js&"
export * from "./WorkTools.vue?vue&type=script&lang=js&"
import style0 from "./WorkTools.vue?vue&type=style&index=0&id=dcff45f0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcff45f0",
  null
  
)

export default component.exports